import { cn } from "~/shared/lib/utils";

export type SystemMessageLevel = "info" | "warning" | "error";

interface SystemMessageRowProps {
    text: string;
    level?: SystemMessageLevel;
}

const LEVEL_CLASSES: Record<SystemMessageLevel, string> = {
    info: "border-zinc-700/60 bg-zinc-900/40 text-zinc-400",
    warning: "border-amber-500/30 bg-amber-500/10 text-amber-300",
    error: "border-red-500/30 bg-red-500/10 text-red-300",
};

// Центральная пилюля в ленте — для системных сигналов вне обычного
// flow сообщений (например, `Session status — N tasks in progress`).
// Не привязана к message-id, не имеет анкоры для MessageScrollNav.
export function SystemMessageRow({ text, level = "info" }: SystemMessageRowProps) {
    return (
        <div className="flex w-full justify-center py-2" role="status" aria-live="polite">
            <span className={cn("rounded-full border px-3 py-1 text-xs font-medium", LEVEL_CLASSES[level])}>
                {text}
            </span>
        </div>
    );
}
